import { OrderType } from "@/types";
import { TableInfoItem } from "./tableInfoItem";
import { formatOrderTypeToString } from "@/utils/scanToOrderUtils";

export interface ScanToOrderCartTableInfoProps {
  tableName: string;
  orderType: OrderType;
}

export const ScanToOrderCartTableInfo = ({
  tableName,
  orderType,
}: ScanToOrderCartTableInfoProps) => {
  const orderTypeText = formatOrderTypeToString(orderType);
  return (
    <div
      data-testid="scan-to-order-cart-table-info"
      className="flex pb-4 mx-4 flex-row columns-2 justify-normal"
    >
      <TableInfoItem item={"Order type"} value={orderTypeText} />
      <TableInfoItem item={"Table number"} value={tableName} />
    </div>
  );
};
